import { useSyncExternalStore } from 'react'

/**
 * Per-browser preference for a balances list (John, Oct 30 2026): small
 * balances are hidden by default and the dollar line is his to set. One
 * store per list: the Holdings table and the Kraken card each keep their
 * own value and switch (John, Nov 4 2026), behind the same control.
 */
export type HoldingsFilter = { hideSmall: boolean; minUsd: number }

export const DEFAULT_HOLDINGS_FILTER: HoldingsFilter = { hideSmall: true, minUsd: 0.05 }

export type FilterStore = {
  use: () => HoldingsFilter
  set: (patch: Partial<HoldingsFilter>) => void
}

function createFilterStore(key: string): FilterStore {
  function read(): HoldingsFilter {
    try {
      const raw = window.localStorage.getItem(key)
      if (!raw) return DEFAULT_HOLDINGS_FILTER
      const parsed = JSON.parse(raw) as Partial<HoldingsFilter>
      const minUsd = Number(parsed.minUsd)
      return {
        hideSmall: parsed.hideSmall !== false,
        minUsd: Number.isFinite(minUsd) && minUsd >= 0 ? minUsd : DEFAULT_HOLDINGS_FILTER.minUsd,
      }
    } catch {
      return DEFAULT_HOLDINGS_FILTER
    }
  }
  let current = read()
  const listeners = new Set<() => void>()
  const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }
  return {
    use: () => useSyncExternalStore(subscribe, () => current, () => DEFAULT_HOLDINGS_FILTER),
    set: (patch) => {
      current = { ...current, ...patch }
      try {
        window.localStorage.setItem(key, JSON.stringify(current))
      } catch {
        // storage blocked: the choice lasts for this page
      }
      for (const listener of listeners) listener()
    },
  }
}

/** the Holdings table's */
export const HOLDINGS_FILTER = createFilterStore('dispence.holdings-filter')
/** the Kraken card's (John, Nov 4 2026: "its own value and toggle but same components") */
export const KRAKEN_FILTER = createFilterStore('dispence.kraken-filter')

export const useHoldingsFilter = () => HOLDINGS_FILTER.use()
export const setHoldingsFilter = HOLDINGS_FILTER.set
